import { render } from "./DsField.vue?vue&type=template&id=1819d564&scoped=true"
import script from "./DsField.vue?vue&type=script&lang=js"
export * from "./DsField.vue?vue&type=script&lang=js"

import "./DsField.vue?vue&type=style&index=0&id=1819d564&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1819d564"]])

export default __exports__